import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "submitButton"]
  static values = { conversationId: String, errorMessage: String }

  connect() {
    this.scrollToBottom()
  }

  async sendMessage(event) {
    event.preventDefault()

    const message = this.inputTarget.value.trim()
    if (!message) return

    // Disable form while processing
    this.inputTarget.disabled = true
    this.submitButtonTarget.disabled = true

    // Add user message to UI
    this.addMessage(message, 'user')
    this.inputTarget.value = ''

    // Show loading indicator
    const loadingIndicator = document.getElementById('loading-indicator')
    if (loadingIndicator) {
      loadingIndicator.classList.remove('hidden')
    }

    try {
      const response = await fetch(`/chats/${this.conversationIdValue}/send_message`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.getCSRFToken()
        },
        body: JSON.stringify({ message: message })
      })

      const data = await response.json()

      if (response.ok) {
        // Add assistant response to UI
        this.addMessage(data.assistant_message, 'assistant')

        // If context was exceeded, reload the page after a delay to start fresh
        if (data.context_exceeded) {
          setTimeout(() => {
            window.location.reload()
          }, 2500)
        }
      } else {
        this.addMessage(this.errorMessageValue || 'Sorry, I encountered an error. Please try again.', 'assistant')
      }
    } catch (error) {
      console.error('Error sending message:', error)
      this.addMessage(this.errorMessageValue || 'Sorry, I encountered an error. Please try again.', 'assistant')
    } finally {
      // Hide loading indicator
      if (loadingIndicator) {
        loadingIndicator.classList.add('hidden')
      }

      // Re-enable form
      this.inputTarget.disabled = false
      this.submitButtonTarget.disabled = false
      this.inputTarget.focus()
    }
  }

  addMessage(content, role) {
    const messagesContainer = document.getElementById('chat-messages')

    const messageDiv = document.createElement('div')
    messageDiv.className = role === 'user'
      ? 'flex justify-end'
      : 'flex justify-start'

    const bubbleDiv = document.createElement('div')
    if (role === 'user') {
      bubbleDiv.className = 'text-white rounded-lg px-4 py-2 max-w-[80%] sm:max-w-xs lg:max-w-md'
      bubbleDiv.style.backgroundColor = '#7094e0'
    } else {
      bubbleDiv.className = 'bg-gray-100 text-gray-900 rounded-lg px-4 py-2 max-w-[80%] sm:max-w-xs lg:max-w-md'
    }

    const textP = document.createElement('p')
    textP.className = 'text-sm whitespace-pre-wrap'
    textP.textContent = content

    bubbleDiv.appendChild(textP)
    messageDiv.appendChild(bubbleDiv)
    messagesContainer.appendChild(messageDiv)

    this.scrollToBottom()
  }

  scrollToBottom() {
    const messagesContainer = document.getElementById('chat-messages')
    if (messagesContainer) {
      messagesContainer.scrollTop = messagesContainer.scrollHeight
    }
  }

  getCSRFToken() {
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content')
  }
}
